export default "__VITE_ASSET__B8_NhFR4__"